const tryConnection = () =>
{
    
}

export default tryConnection;